import { render, staticRenderFns } from "./crosstabTitle.vue?vue&type=template&id=31a5cb9e&scoped=true"
import script from "./crosstabTitle.vue?vue&type=script&lang=js"
export * from "./crosstabTitle.vue?vue&type=script&lang=js"
import style0 from "./crosstabTitle.vue?vue&type=style&index=0&id=31a5cb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5cb9e",
  null
  
)

export default component.exports